module.exports = __webpack_public_path__ + "static/Hello-World-d7966ce004aa682f3daba20639c3ed5b.webm";